import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cookie from 'react-cookie';
import idx from 'idx';
import { getSubcategorySlug } from 'common/ducks/categories';

const SHOWING_DRIFT_COOKIE_NAME = "showing_drift";

const LAST_PROJECT_ACTIONS = {
  draft: 'created draft',
  open: 'posted project',
  awarded: 'started wrapup',
  completed: 'completed project'
};

export const openChat = () => {
  runCommand("api.openChat");
  document.body.classList.add("drift-visible");
}

const runCommand = (command, args) => {
  if (!window.drift) {
    console.log('Drift command:', command);
  } else {
    /* drift didn't get loaded yet - queue for when it does */
    if (!window.drift.api) {
      window.queuedDriftCommands = window.queuedDriftCommands || [];
      window.queuedDriftCommands.push([command, args]);
    } else {
      const parts = command.split('.');
      if (parts[2]) {
        window.drift[parts[0]][parts[1]][parts[2]](args);
      } else if (parts[1]) {
        window.drift[parts[0]][parts[1]](args);
      } else {
        window.drift[parts[0]](args);
      }
    }
  }
};


export default class DriftChat extends Component {
  setUserAttributes() {
    const { user, categories } = this.props;
    const project = user.last_updated_owned_project;
    const subCategorySlug = project? getSubcategorySlug(categories, project.sub_category) : null;

    runCommand("api.setUserAttributes", {
      email: idx(user, _ => _.email),
      last_project_action: project? (LAST_PROJECT_ACTIONS[project.status] || "none") : "none",
      last_project_sub_category: subCategorySlug || "none"
    });
  }

  update(prevProps, props) {
    if (props.shouldShow && !prevProps.shouldShow) {
      this.show();
    } else if (!props.shouldShow && prevProps.shouldShow) {
      this.hide();
    }
  }

  show() {
    const { bodyClasses, initiallyHidden } = this.props;

    cookie.save(SHOWING_DRIFT_COOKIE_NAME, true, { path: "/" });
    window.driftShownAtLeastOnce = true;

    this.setUserAttributes();
    runCommand('api.widget.show');
    runCommand('config', { enableCampaigns: true });
    document.body.classList.add("with-drift");

    if (!initiallyHidden) {
      document.body.classList.add("drift-visible");
    }

    /* add `bodyClasses` to body if provided */
    if (bodyClasses) {
      bodyClasses.split(' ').forEach(cls => document.body.classList.add(cls));
    }
  }

  hide() {
    const { bodyClasses } = this.props;

    cookie.remove(SHOWING_DRIFT_COOKIE_NAME, { path: "/" });

    runCommand('api.widget.hide');
    runCommand('config', { enableCampaigns: false });

    document.body.classList.remove("with-drift", "drift-visible");

    if (bodyClasses) {
      bodyClasses.split(' ').forEach(cls => document.body.classList.remove(cls));
    }
  }

  componentDidMount() {
    this.props.fetchChatPermsIfNeeded();
    this.update({}, this.props);
  }

  componentDidUpdate(prevProps) {
    this.update(prevProps, this.props);
  }

  componentWillUnmount() {
    this.update(this.props, {});
  }

  render() {
    return null;
  }
}
